import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  DEFAULT_REPORTING_TIME_ZONE,
  isReportingTimeZone,
  type ReportingTimeZone,
} from "@/lib/reporting-time-zone";

interface ReportingTimeZoneState {
  timeZone: ReportingTimeZone;
  setTimeZone: (timeZone: ReportingTimeZone) => void;
}

export const useReportingTimeZoneStore = create<ReportingTimeZoneState>()(
  persist(
    (set) => ({
      timeZone: DEFAULT_REPORTING_TIME_ZONE,
      setTimeZone: (timeZone) => set({ timeZone }),
    }),
    {
      name: "adpilot-reporting-time-zone",
      // The persisted value reaches Intl.DateTimeFormat during the first render
      // of every authed page; an unrecognised zone would throw a RangeError that
      // no reload can clear, so anything unexpected falls back to the default.
      merge: (persisted, current) => {
        const timeZone = (persisted as Partial<ReportingTimeZoneState> | undefined)?.timeZone;
        return {
          ...current,
          timeZone: isReportingTimeZone(timeZone) ? timeZone : DEFAULT_REPORTING_TIME_ZONE,
        };
      },
    },
  ),
);
